import type {
  ChecklistImage,
  ChecklistReportImage,
} from '../types/checklistImages';

export function toChecklistReportImages(
  images: ChecklistImage[],
): ChecklistReportImage[] {
  return images.map(image => ({
    id: image.id,
    name: image.name,
    url: image.previewUrl,
  }));
}

export const waitForImagesToLoad = async (
  imageUrls: string[],
): Promise<void> => {
  await Promise.all(
    imageUrls.map(
      url =>
        new Promise<void>(resolve => {
          const image = new Image();

          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = url;

          if (image.complete) {
            resolve();
          }
        }),
    ),
  );
};
